import type { ReactNode } from 'react';

type Props = {
  label: string;
  value: number | string;
  hint?: string;
  accent?: 'design' | 'deliver' | 'adopt' | 'grow' | 'sunrise' | 'sunset';
  icon?: ReactNode;
};

const ACCENT: Record<NonNullable<Props['accent']>, string> = {
  design: 'text-design',
  deliver: 'text-deliver',
  adopt: 'text-adopt',
  grow: 'text-grow',
  sunrise: 'text-sunrise',
  sunset: 'text-sunset',
};

export function StatCard({ label, value, hint, accent, icon }: Props) {
  return (
    <div className="rounded-lg border border-border-subtle bg-surface-2 shadow-card p-4 flex flex-col gap-1.5 min-w-[120px] transition-all hover:bg-surface-hover hover:border-border-strong hover:shadow-card-hover">
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-text-muted">
          {label}
        </span>
        {icon ? (
          <span className={accent ? ACCENT[accent] : 'text-text-subtle'}>{icon}</span>
        ) : null}
      </div>
      <div className="text-2xl font-semibold text-text-strong tabular-nums leading-none">
        {value}
      </div>
      {hint ? <div className="text-xs text-text-muted">{hint}</div> : null}
    </div>
  );
}
